/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateDanceRequest
 */
export interface CreateDanceRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateDanceRequest
     */
    seasonId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateDanceRequest
     */
    choreographerUserId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof CreateDanceRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDanceRequest
     */
    cast: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDanceRequest
     */
    publicNote: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDanceRequest
     */
    internalNote: string | null;
}

/**
 * Check if a given object implements the CreateDanceRequest interface.
 */
export function instanceOfCreateDanceRequest(value: object): value is CreateDanceRequest {
    if (!('seasonId' in value) || value['seasonId'] === undefined) return false;
    if (!('choreographerUserId' in value) || value['choreographerUserId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('cast' in value) || value['cast'] === undefined) return false;
    if (!('publicNote' in value) || value['publicNote'] === undefined) return false;
    if (!('internalNote' in value) || value['internalNote'] === undefined) return false;
    return true;
}

export function CreateDanceRequestFromJSON(json: any): CreateDanceRequest {
    return CreateDanceRequestFromJSONTyped(json, false);
}

export function CreateDanceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDanceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'seasonId': ApiUserTasksGetPageParameterFromJSON(json['seasonId']),
        'choreographerUserId': ApiUserTasksGetPageParameterFromJSON(json['choreographerUserId']),
        'name': json['name'],
        'cast': json['cast'],
        'publicNote': json['publicNote'],
        'internalNote': json['internalNote'],
    };
}

export function CreateDanceRequestToJSON(json: any): CreateDanceRequest {
    return CreateDanceRequestToJSONTyped(json, false);
}

export function CreateDanceRequestToJSONTyped(value?: CreateDanceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'seasonId': ApiUserTasksGetPageParameterToJSON(value['seasonId']),
        'choreographerUserId': ApiUserTasksGetPageParameterToJSON(value['choreographerUserId']),
        'name': value['name'],
        'cast': value['cast'],
        'publicNote': value['publicNote'],
        'internalNote': value['internalNote'],
    };
}

